import { ChakraProvider, Switch, useToast } from '@chakra-ui/react';
import { DashboardHooks, useToggleAgreementOnlineCompany } from '@partiu/api/dashboard/hooks.ts';
import { useQueryClient } from 'react-query';
import { useMemo } from 'react';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';

export function ToggleAgreementOnlineCompanySwitch({ value, companyID }: { value: number[]; companyID: number }) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { id } = useTheme();
  const checked = useMemo(() => {
    return !value.includes(id as number);
  }, [value]);
  const mutation = useToggleAgreementOnlineCompany({
    onSuccess() {
      toast({
        title: 'Sucesso',
        description: `Empresa ${value ? 'desativada' : 'ativada'} com sucesso`,
        status: 'success',
      });
      queryClient.invalidateQueries(DashboardHooks.OnlineCompany).then();
    },
    onError() {
      toast({
        title: 'Erro',
        description: `Não foi possivel ${
          value ? 'desativar' : 'ativar'
        } a empresa. Tente novamente mais tarde ou entre em contato com o suporte em suporte@partiu.com.br`,
        status: 'error',
      });
    },
  });

  return (
    <ChakraProvider>
      <Switch
        onChange={() => mutation.mutate(companyID)}
        disabled={mutation.isLoading}
        isChecked={checked}
        size={'md'}
      />
    </ChakraProvider>
  );
}
